export default __webpack_public_path__ + "static/media/august2023-1.fead47b0.jpg";